<mat-card class="formCard">
    <mat-card-title>
        <mat-card-title>Frequently Asked Questions
            <button *ngIf="data" class="close-button" [mat-dialog-close]="true" id="closeFAQ" mat-button>
                <mat-icon>close</mat-icon>
            </button>
        </mat-card-title>
        <div *ngIf="admin" class="right">
            <button (click)="categoryPopup()" aria-label="Manage FAQ categories" color="primary" id="FAQsetting" mat-icon-button>
                <mat-icon>settings</mat-icon>
            </button>
        </div>
    </mat-card-title>
    <app-hourglass *ngIf="categories.length < 1"></app-hourglass>
    <app-autocomplete #autoComplete (autocompleteInput)="onSearchChanged($event)" (loadRequest)="load($event)"
                      (selection)="searchQuestionSelected($event)" [filterConfig]="filterConfig" [doAutofocus]="false"
                      [hint]="'Search by text'" [objects]="searchQuestions" [options]="searchQuestionsFormatted"
                      [page]="pageNum"></app-autocomplete>
    <mat-tab-group (selectedTabChange)="onTabChange($event)"
                   [selectedIndex]="selected.value" id="SelectedTab">
        <mat-tab *ngFor="let category of categories; let i = index" id="category-{{i}}"
                 label="{{category.name | titlecase}}">
            <mat-card>
                <mat-expansion-panel
                    *ngFor="let question of selectedCategory.questions; trackBy: trackById; let j = index"
                    expanded="{{questionText === question.question}}">
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            {{question.question}}
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <pre id="questionFaq-{{i}}-{{j}}" [innerHtml]="question.answer" markdown ngPreserveWhitespaces></pre>
                    <div *ngIf="admin" class="right">
                        <mat-icon (click)="update(question)" class="spaced_button" color="primary"
                                  id="UpdateFaqQuestion-{{i}}-{{j}}">
                            edit
                        </mat-icon>
                        <mat-icon (click)="delete(question)" color="primary" id="DeleteFaqQuestion-{{i}}-{{j}}">
                            delete
                        </mat-icon>
                    </div>
                </mat-expansion-panel>
            </mat-card>
        </mat-tab>
    </mat-tab-group>

    <div class="project">
        <div *ngIf="admin" class="right">
            <button (click)="newQuestionPopup()" color="primary" id="AddQuestion" mat-raised-button>Add Question
            </button>
        </div>
        <h6 class="link"><a href="https://confluence.ssnc-corp.cloud/pages/viewpage.action?pageId=25838515" id="FAQLink"
                            target="_blank">
            SS&C Alerting Project Page
        </a></h6>
    </div>
</mat-card>
